import { useEffect, useState } from "react";
import axios from "utils/axios";
import { Grid, Hidden, Stack, TextField, Typography } from "@pankod/refine-mui";
import { toast } from "react-toastify";
import { format } from "date-fns";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";
import SimpleUploadZone from "../../components/SimpleUploadZone";
import DescriptionIcon from "@mui/icons-material/Description";
import ImageIcon from "@mui/icons-material/Image";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

export default function CompFields({
  register,
  errors,
  control,
  getValues,
  setValue,
  record,
  user,
}) {
  const [advertisementFile, setAdvertisementFile] = useState();

  useEffect(() => {
    if (record && record.file) setAdvertisementFile(record.file);
    if (record) {
      // console.log(getValues("title"));
      // console.log(record);
      setValue("title", record.title);
      setValue("description", record.description);
      setValue("publication_date", record.publication_date);
      setValue("expiry_date", record.expiry_date);
    }
  }, [getValues, record, setValue]);

  // base fields
  const fields = [
    {
      label: "Titolo",
      name: "title",
      required: true,
      type: "text",
      md: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "Descrizione",
      name: "description",
      required: true,
      type: "text",
      lines: 8,
      md: 12,
      style: { marginBottom: "20px" },
    },
    {
      label: "Data di publicazione",
      name: "publication_date",
      required: true,
      type: "date",
      md: 4,
      lg: 3,
      xs: 6,
      defaultValue: format(Date.now(), "yyyy-MM-dd"),
      min: format(Date.now(), "yyyy-MM-dd"),
    },
    {
      label: "Data di scadenza",
      name: "expiry_date",
      required: true,
      type: "date",
      md: 4,
      lg: 3,
      xs: 6,
      defaultValue: format(Date.now(), "yyyy-MM-dd"),
      min: format(Date.now(), "yyyy-MM-dd"),
    },
  ];

  const removeDocument = async (docId) => {
    try {
      await axios.delete(`/api/upload/files/${docId}`);

      setAdvertisementFile(null);
      setValue("file", null);
      toast.success("documento eliminato");
    } catch (error) {
      toast.error("Si è verificato un errore");
    }
  };

  console.log("CARICO", user);
  if (!user) return null;

  return (
    <Grid container spacing={3} sx={{ maxWidth: "1200px" }}>
      <Grid item xs={12}>
        <Grid container spacing={2} style={{ padding: "30px" }}>
          {fields.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                {...field}
                register={register}
                control={control}
                errors={errors}
                getValues={getValues}
                setValue={setValue}
              />
            );
          })}
          <Hidden>
            <TextField
              {...register("municipality")}
              hidden
              required={true}
              value={user?.municipality?.id}
              type="text"
              style={{ height: "0", display: "none" }}
            />
          </Hidden>
        </Grid>
        <Grid
          container
          spacing={2}
          direction="column"
          style={{ padding: "30px" }}
          justifyContent="center"
          gap={2}
          alignItems="start"
        >
          <Typography variant="h6" ml={2}>
            CAPITOLATO
          </Typography>

          {advertisementFile ? (
            <Stack direction="row" alignItems="center" gap={2} marginLeft={2}>
              {advertisementFile?.mime.includes("image") ? (
                <ImageIcon />
              ) : (
                <DescriptionIcon />
              )}
              {advertisementFile.name}
              <DeleteForeverIcon
                onClick={() => removeDocument(advertisementFile.id)}
                sx={{ color: "red", cursor: "pointer" }}
              />
            </Stack>
          ) : (
            <SimpleUploadZone
              label="CARICA DOCUMENTO"
              onChange={async (file) => {
                try {
                  console.log(file);
                  setValue("file", file.id);
                  setAdvertisementFile(file);
                  toast.success("Documento caricato con successo");
                } catch (error) {
                  console.log(error);
                  toast.error("Documento non caricato");
                }
              }}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
